import {
  easeLinear,
  interpolateString,
  linkHorizontal,
  linkVertical,
  select,
  tree as d3Tree,
} from "d3";
import { isSmallViewport } from "../../utils";

export const CHART_LAYOUT = {
  HORIZONTAL: 0,
  VERTICAL: 1,
};

export const renderLink = (orientation) => {
  return orientation === CHART_LAYOUT.HORIZONTAL
    ? linkHorizontal()
        .y((d) => d.x)
        .x((d) => d.y)
    : linkVertical()
        .x((d) => d.x)
        .y((d) => d.y);
};

export const renderName = (
  showOnlyHighlightedNames = false,
  highlightedCompanies,
  chartOrientation
) => {
  if (isSmallViewport()) return "";
  if (showOnlyHighlightedNames) {
    return (d) =>
      highlightedCompanies[chartOrientation].indexOf(d.data.name) >= 0
        ? d.data.name
        : "";
  } else {
    return (d) => d.data.name;
  }
};

// max hierarchy of tree
const MAX_TREE_LEVELS = 12;

export const transformFunc = (orientation) => {
  return orientation === CHART_LAYOUT.HORIZONTAL
    ? (d) => `translate(${d.y}, ${d.x})`
    : (d) => `translate(${d.x}, ${d.y})`;
};

export const transformChart = (orientation, bounds) => {
  return orientation === CHART_LAYOUT.HORIZONTAL
    ? `translate(0, ${bounds.height / 2})`
    : `translate(${bounds.width / 2}, 0)`;
};

export const anchorText = (orientation, bounds) => (d) => {
  if (orientation === CHART_LAYOUT.HORIZONTAL) {
    if (!d.children) return "start";
    return "middle";
  } else {
    // if (!d.children) return "middle";
    return d.x < bounds.width / 2 === !d.children ? "start" : "end";
  }
};

export const tree = (orientation, depth = MAX_TREE_LEVELS) => {
  if (orientation === CHART_LAYOUT.HORIZONTAL) {
    return (
      d3Tree()
        // .nodeSize([50, 140])
        .nodeSize([40, window.innerWidth / depth])
        .separation((a, b) => (a.parent === b.parent ? 12 : 3) / a.depth)
    );
  } else {
    return (
      d3Tree()
        // .nodeSize([180, 60])
        .nodeSize([window.innerHeight / depth, window.innerWidth / depth])
        .separation((a, b) => (a.parent === b.parent ? 3.5 : 2) / a.depth)
    );
  }
};

export const revealPath = (path) =>
  path
    .transition()
    .duration(1000)
    .delay((d, i) => i * 100 + 100)
    .ease(easeLinear)
    .attrTween("stroke-dasharray", function () {
      const length = this.getTotalLength();
      return interpolateString(`0,${length}`, `${length},${length}`);
    });

// utility function to wrap text
export function wrapText(text, width) {
  text.each(function () {
    var text = select(this),
      words = text.text().split(/\s+/).reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.1, // ems
      y = text.attr("y"),
      dy = parseFloat(text.attr("dy")) || 0.4,
      dx = parseFloat(text.attr("dx")),
      tspan = text
        .text(null)
        .append("tspan")
        .attr("x", 0)
        .attr("y", y)
        .attr("dy", dy + "em");
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text
          .append("tspan")
          .attr("x", dx)
          .attr("y", y)
          .attr("dy", ++lineNumber * lineHeight + dy + "em")
          .text(word);
      }
    }
  });
}
